import { IconCategory, IconCategoryFilled, IconFrame, IconFrameFilled, IconHome1, IconHome1Filled, IconShoppingCart, IconShoppingCartFilled } from '@/features/icons';
import { NavigationBarItemType, NavigatoinBarItem } from './types';
export const NAVIGATION_ITEMS: NavigationBarItemType[] = [{
  id: NavigatoinBarItem.HomePage,
  title: 'خانه',
  href: '/',
  default_icon: IconHome1,
  active_icon: IconHome1Filled
}, {
  id: NavigatoinBarItem.Categories,
  title: 'دسته‌بندی',
  href: '#menu',
  default_icon: IconCategory,
  active_icon: IconCategoryFilled
}, {
  id: NavigatoinBarItem.Cart,
  title: 'سبد خرید',
  href: '/cart',
  default_icon: IconShoppingCart,
  active_icon: IconShoppingCartFilled
}, {
  id: NavigatoinBarItem.Profile,
  title: 'حساب کاربری',
  href: '/profile',
  default_icon: IconFrame,
  active_icon: IconFrameFilled
}];
export const exceptedUrls = ['/checkout/shipping', '/checkout/payment', '/products/', '/profile/', '/login-failed'];